import _jsx from "@babel/runtime/helpers/jsx";
var _div;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Checkbox, CloseButton, Glyphicon } from 'reaxl';
const renderSecondaryContent = secondaryContent => secondaryContent && /*#__PURE__*/_jsx("div", {}, void 0, secondaryContent);

/**
 *  Add checkbox for selecting listing
 *
 */
function InventoryListingAddOns(_ref) {
  let {
    className,
    emailSent,
    label = 'Select',
    listing,
    onListingRemove,
    onListingSelect,
    secondaryContent,
    selected = false,
    shareButton,
    ...rest
  } = _ref;
  const showListingSelect = typeof onListingSelect === 'function';
  const showListingRemove = typeof onListingRemove === 'function';
  if (!secondaryContent && !showListingRemove && !showListingSelect && !emailSent && !shareButton) {
    return null;
  }
  const renderEmailSent = () => emailSent && (_div || (_div = /*#__PURE__*/_jsx("div", {
    className: "col-xs-10 margin-top-3 text-success"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "success",
    className: "text-size-400 margin-horizontal-1"
  }), "Email Sent")));
  const renderSelect = () => showListingSelect &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- only capturing propagation, shouldn't be clickable
  _jsx("div", {
    className: "col-xs-10",
    onClick: event => event.stopPropagation()
  }, void 0, /*#__PURE__*/_jsx(Checkbox, {
    label: label,
    onClick: event => onListingSelect(event, listing, selected),
    checked: selected,
    value: listing.id,
    name: listing.listingTitle
  }));
  const renderRemove = () => onListingRemove && /*#__PURE__*/_jsx("div", {
    className: "pull-right col-xs-2"
  }, void 0, /*#__PURE__*/_jsx(CloseButton, {
    onClick: event => {
      event.stopPropagation();
      onListingRemove(event, listing);
    }
  }));
  const renderShareButton = () => /*#__PURE__*/_jsx("div", {
    className: "col-xs-3 col-sm-4 col-md-3 col-xs-offset-9 col-sm-offset-8 col-md-offset-9",
    onClick: event => event.stopPropagation(),
    role: "button",
    tabIndex: "0"
  }, void 0, shareButton);
  const rootClassName = clsx('row', 'inventory-listing-addons', 'padding-top-2 padding-bottom-4 padding-horizontal-2', 'text-left', className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: rootClassName
  }, rest), renderRemove(), renderSelect(), renderShareButton(), renderSecondaryContent(secondaryContent), renderEmailSent());
}
export default InventoryListingAddOns;